import React, {Component} from 'react';
import {t} from '@lingui/macro';
import {connect} from 'react-redux';
import {Modal} from 'antd';
import ListMenu from "..";
import InstructionActions from 'bukku/redux/Instruction/actions';
import { SubscriptionCheck } from '../../Access/helper/subscription/SubscriptionCheck';

const {
    deleteInstruction,
} = InstructionActions;

class InstructionListMenu extends Component {
    getItems = () => {
        const { record } = this.props;
        const hasSubscription = SubscriptionCheck.withTransactionType(record.transaction_type)
            .hasSubscriptionTo();

        const items = [];

        items.push({
            key: 'view',
            label: t`View`,
            url: `/cp/instructions/${record.id}`,
            overrideHasSubscription: hasSubscription,
        });
        // items.push({
        //     key: 'viewTransactions',
        //     label: t`View Transactions`,
        //     action: false
        // });
        items.push({
            key: 'delete',
            label: t`Delete`,
            action: () => this.deleteInstruction(record),
            overrideHasSubscription: hasSubscription,
            isDelete: true,
        });
        return items;
    };

    deleteInstruction(record) {
        const { deleteInstruction } = this.props;

        Modal.confirm({
            title: t`Delete Recurring Instruction`,
            content: t`Do you really want to delete the recurring instruction ${record.name}?`,
            onOk() {
                deleteInstruction(record.id);
            },
            onCancel() {},
            okText: t`Remove`,
            cancelText: t`Cancel`,
        });
    }

    render() {
        return (
            <ListMenu items={this.getItems()} />
        );
    }
}
export default connect(() => ({
}), {
    deleteInstruction,
})(InstructionListMenu);
